import { FC } from 'react';

import { Box, SxProps } from '@mui/material';
import Image from 'next/image';

import { grayColors, primaryColors } from '~components/theme/styles/colors';

export enum VestaIcons {
  BADGE = '/v2/icons/badge.svg',
  BUILDING = '/v2/icons/building.svg',
  COIN = '/v2/icons/coin.svg',
  DISCOVER = '/v2/icons/discover.svg',
  EXCHANGE1 = '/v2/icons/exchange1.svg',
  EXCHANGE2 = '/v2/icons/exchange2.svg',
  GAS1 = '/v2/icons/gas1.svg',
  GAS2 = '/v2/icons/gas2.svg',
  GLOBE = '/v2/icons/globe.svg',
  HEART = '/v2/icons/heart.svg',
  LOCK = '/v2/icons/lock.svg',
  UNLOCK = '/v2/icons/unlocked.svg',
  MAGNIFIER = '/v2/icons/magnifier.svg',
  MONEY = '/v2/icons/money.svg',
  PERCENTAGE = '/v2/icons/percentage.svg',
  RECEIPT = '/v2/icons/receipt.svg',
  STAKE = '/v2/icons/stake.svg',
  STATISTIC = '/v2/icons/statistic.svg',
  UPONLY = '/v2/icons/upOnly.svg',
  USER = '/v2/icons/user.svg',
  VAULT = '/v2/icons/vault.svg',
  WALLET = '/v2/icons/wallet.svg',
  VST = '/v2/assets/VST-light.svg',
  PENALTY_OKAY = '/v2/icons/penaltyOkay.svg',
  PENALTY_WARNING = '/v2/icons/penaltyWarning.svg',
  VESTING_WORMHOLE = '/v2/icons/vestingWormhole.svg',
  BOOSTING_LIGHTNING = '/v2/icons/boosting.svg',
}

export enum VestaPartnerIcons {
  BPROTOCOL = '/v2/icons/bProtocol.svg',
  UNISWAP = '/v2/partners/uni.svg',
  SUSHISWAP = '/v2/partners/sushi.svg',
  CURVE = '/v2/partners/curve.svg',
  OPENOCEAN = '/v2/partners/openocean.svg',
  REDACTED = '/v2/partners/redacted.svg',
  AURA = '/v2/partners/aura.svg',
  SYNAPSE = '/v2/partners/synapse.svg',
  LIFI = '/v2/partners/lifi.svg',
  VERILOG = '/v2/partners/verilog.svg',
  ONEINCH = '/v2/partners/1inch.svg',
  RISKDAO = '/v2/partners/riskdao.svg',
  CREDPROTOCOL = '/v2/partners/credprotocol.svg',
  GMX = '/v2/assets/GMX-light.svg',
  OHM = '/v2/assets/gOHM-light.svg',
  BAL = '/v2/assets/BAL-light.svg',
  RADIANT = '/v2/partners/radiant.svg',
}

export enum VestaNetworkIcons {
  ARBITRUM = '/v2/networks/arbitrum.svg',
}

export type VestaIconTypes = VestaNetworkIcons | VestaPartnerIcons | VestaIcons;

export const VestaIcon: FC<{
  icon: VestaIcons | VestaNetworkIcons | VestaPartnerIcons;
  round?: boolean;
  color?: string;
  sx?: SxProps;
  outerContainerSx?: SxProps;
  size?: number;
  noBg?: boolean;
  noBorder?: boolean;
  containerPadding?: number;
}> = ({ icon, round, sx, outerContainerSx, size = 24, noBg, noBorder, color, containerPadding = 16 }) => {
  const iconSrc = icon;
  const containerSize = containerPadding + size;

  const actualContainerSize = noBg && noBorder ? (size ? size : 30) : size ? containerSize : 40;

  return (
    <Box
      sx={{
        position: 'relative',
        width: actualContainerSize,
        height: actualContainerSize,
        ...outerContainerSx,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: actualContainerSize,
          height: actualContainerSize,
          borderRadius: round ? '64px' : '6px',
          background: !noBg ? grayColors[900] : 'transparent',
          border: !noBorder ? '1px solid ' + primaryColors[900] : undefined,
          backgroundClip: 'padding-box',
          position: 'absolute',
          zIndex: 1,
          ...sx,
        }}
      >
        <Image width={`${size}px`} height={`${size}px`} src={iconSrc} color={color} />
      </Box>
    </Box>
  );
};
